export default "###### My Documents\n\nYou can view and download documents relating to your purchase here.\n";